import api from "../../api";

export function submitData(data) {
  api.post("/team_stages", data)
    .catch(error => {
      console.log(error);
    });
}
